<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <div class="level">
        <div class="level-left">
          <h1 class="title is-5">{{ $t('routes.shortBySenders') }}</h1>
        </div>
        <div class="level-right">
          <div class="control">
            <button @click="loadData(true)" class="button is-success">{{ $t('interface.export') }}</button>
          </div>
        </div>
      </div>
      <div class="level">
        <div class="level-left">
          <div class="field controls is-grouped">
            <div class="control">
              <b-field :label="$t('reports.startDate')">
                <b-datepicker v-model="startDate"
                              @input="loadData()"
                              :month-names="$locale.datePicker().month"
                              :day-names="$locale.datePicker().days"
                              icon="calendar-today">
                </b-datepicker>
              </b-field>
            </div>
          </div>
        </div>
      </div>
      <div class="mobile-scroll" ref="report">
        <table class="report-table" border="1">
          <thead>
          <tr>
            <td class="has-text-centered" width="20%">{{ $t('reports.incomingDocs') }}</td>
            <td class="has-text-centered" width="60%">{{ $t('reports.from') }}</td>
            <td class="has-text-centered">{{ $t('reports.count') }}</td>
          </tr>
          </thead>
          <tbody>
          <template v-for="item in shortBySendersData.incoming">
            <tr>
              <td></td>
              <td>{{ item.title }}</td>
              <td class="has-text-centered">{{ item.docs_count }}</td>
            </tr>
          </template>
          <tr>
            <td class="has-text-centered" colspan="2">{{ $t('reports.total') }}</td>
            <td class="has-text-centered">{{ total(shortBySendersData.incoming) }}</td>
          </tr>
          </tbody>
          <thead>
          <tr>
            <td class="has-text-centered" width="20%">{{ $t('reports.innerDocs') }}</td>
            <td class="has-text-centered" width="60%">{{ $t('reports.from') }}</td>
            <td class="has-text-centered">{{ $t('reports.count') }}</td>
          </tr>
          </thead>
          <tbody>
          <template v-for="item in shortBySendersData.outgoing">
            <tr>
              <td></td>
              <td>{{ item.title }}</td>
              <td class="has-text-centered">{{ item.docs_count }}</td>
            </tr>
          </template>
          <tr>
            <td class="has-text-centered" colspan="2">{{ $t('reports.total') }}</td>
            <td class="has-text-centered">{{ total(shortBySendersData.outgoing) }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import {mapGetters, mapState, mapActions} from 'vuex'
  import {prepareDate, userDetail, objectToURLParams, outputFile} from '@/utils'
  import {API_HOST} from '@/localSettings'

  let startDate = new Date()

  startDate.setDate(1)

  export default {
    components: {
      DashboardLayout
    },
    data() {
      return {
        startDate
      }
    },
    methods: {
      userDetail,
      goTo(route) {
        this.$router.push({name: route})
      },
      loadData(excel = false) {
        this.$store.dispatch('Reports/shortBySenders', {
          start_date: prepareDate(this.startDate),
          export: excel
        }).then(() => {
          if(excel) {
            outputFile('report.doc', this.exportData)
          }
        })
      },
      total(items) {
        let total = 0
        items.map(item => total += item.docs_count)
        return total
      }
    },
    mounted() {
      this.$store.commit('Reports/CLEAR', 'shortBySendersData')
      this.loadData()
    },
    computed: {
      ...mapState('Reports', ['shortBySendersData', 'exportData']),
      breadcrumbs() {
        return [
          {name: 'reportsList', path: 'reportsList'},
          {name: 'shortBySenders'}
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
